class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartButtonOpen = document.querySelector('#cart-button--open');
    this.cartButtonClose = document.querySelector('#cart-button--close');
    this.cartDrawer = this;
    this.overlay = document.querySelector('#overlay');
    this.checkoutButton = document.querySelector('#checkout-button');
    this.cartForm = null;
    this.cartItems = [];
    this.updateTimeout = null;
    this.pendingUpdates = {};

    this.sectionsToUpdate = ['cart-form', 'b2c-cart-bubble'];

    document.addEventListener('DOMContentLoaded', this.initialize.bind(this));
  }

  initialize = () => {
    this.cartButtonOpen.addEventListener('click', this.handleOpenCartDrawer);
    this.cartButtonClose.addEventListener('click', this.closeCartDrawer);
    this.overlay.addEventListener('click', this.handleOverlayClick);

    this.cartForm = document.querySelector('#cart-form');
    this.getCartItems();
    this.cartForm.addEventListener('submit', this.handleFormSubmit);

    // Listen for the cart:refresh event
    document.addEventListener('cart:refresh', this.handleProductAddedToCart);
    document.addEventListener('cart:open', this.handleOpenCartDrawer);
    document.addEventListener('cart:close', this.closeCartDrawer);

    // Checkout-Button Weiterleitung
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = '/checkout';
      });
    }
  };

  openCartDrawer = () => {
    this.cartDrawer.classList.add('open');
    this.overlay.classList.add('active');
  };

  closeCartDrawer = () => {
    this.cartDrawer.classList.remove('open');
    this.overlay.classList.remove('active');
  };

  handleOpenCartDrawer = (event) => {
    event.preventDefault();
    this.openCartDrawer();
  };

  handleOverlayClick = (event) => {
    if (event.target === this.overlay) {
      this.closeCartDrawer();
    }
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    // Handle form submission if needed
  };

  getCartItems = () => {
    // todo: cart button bubble rendering to not need this code
    if (!this.cartButtonOpen) {
      this.cartButtonOpen = document.querySelector('#cart-button--open');
    }
    if (!this.cartForm) {
      this.cartForm = document.querySelector('#cart-form');
    }
    this.cartItems = Array.from(this.cartForm.querySelectorAll('cart-item'));
    this.checkCart();
  };

  checkCart = () => {
    this.removeCartError();
    if (this.checkCart__CalenderAddOnCheck()) return false;
    return true;
  }

  checkCart__CalenderAddOnCheck = () => {
    var hasCalender = false;
    var hasAddOn = false;
    this.cartItems.forEach(item => {
      //if(item.dataset.variantId == 56021399044361 || item.dataset.variantId == 56423411319049) hasCalender = true;
      //if(item.dataset.variantId == 43636421198089 || item.dataset.variantId == 55720223605001) hasAddOn = true;
    });
    if (!hasCalender && hasAddOn){
      this.throwCartError("Unsere Boxen müssen zusammen mit dem Adventskalender bestellt werden.")
    }
  };

  throwCartError = (message) =>{
    this.disableCheckoutButton();
    document.getElementById("cart-error").innerHTML = message;
  }

  removeCartError = () =>{
    this.enableCheckoutButton();
    document.getElementById("cart-error").innerHTML = "";
  }

  updateCartItems = (updates) => {
    Object.assign(this.pendingUpdates, updates);

    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(this.sendCartUpdates, 300);
  };

  sendCartUpdates = () => {
    //console.log(this.pendingUpdates);

    this.disableCheckoutButton();

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: this.pendingUpdates,
        sections: this.sectionsToUpdate,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then(this.handleCartUpdateResponse)
      .catch(this.handleCartUpdateError);

    this.pendingUpdates = {};
  };

  handleCartUpdateResponse = (data) => {
    //console.log('Cart updated:', data);
    this.renderSections(data.sections);
    this.enableCheckoutButton();
    this.getCartItems();
  };

  renderSections = (sectionData) => {
  if (!sectionData) return;
  for (const [sectionId, html] of Object.entries(sectionData)) {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      const temp = document.createElement('div');
      temp.innerHTML = html.trim();

      // Finde das erste Element (der äußere Container)
      const outer = Array.from(temp.childNodes).find(node => node.nodeType === 1);
      if (outer) {
        //console.log(`[CartDrawer] Replacing content of #${sectionId} with innerHTML of outer container:`, outer);
        sectionElement.innerHTML = outer.innerHTML;
      } else {
        // Fallback: falls kein Element gefunden wird
        console.warn(`[CartDrawer] No outer element found in HTML for #${sectionId}, using raw HTML.`);
        sectionElement.innerHTML = html;
      }
    } else {
      console.warn(`[CartDrawer] Section element #${sectionId} not found in DOM.`);
    }
  }
    this.reatachListeners();
    this.checkCart();
  };

  reatachListeners = () => {
    this.cartButtonOpen = document.querySelector('#cart-button--open');
    this.cartButtonClose = document.querySelector('#cart-button--close');
    this.cartButtonOpen.addEventListener('click', this.handleOpenCartDrawer);
    this.cartButtonClose.addEventListener('click', this.closeCartDrawer);

    // Checkout-Button erneut holen und Listener setzen
    this.checkoutButton = document.querySelector('#checkout-button');
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = '/checkout';
      });
    }
  }

  handleCartUpdateError = (error) => {
    console.error('Error:', error);
    this.enableCheckoutButton();
  };

  disableCheckoutButton = () => {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
    }
  };

  enableCheckoutButton = () => {
    if (this.checkoutButton) {
      this.checkoutButton.disabled = false;
    }
  };

  handleProductAddedToCart = () => {
    //console.log('Product added to cart event received');
    const sectionsQuery = this.sectionsToUpdate.join(',');
    fetch(`${window.location.pathname}?sections=${sectionsQuery}`)
      .then((response) => response.json())
      .then((data) => {
        //console.log('Updated sections:', data);
        this.renderSections(data);
        this.getCartItems();
      })
      .catch((error) => {
        console.error('Error fetching updated sections:', error);
      });
  };
}

customElements.define('cart-drawer', CartDrawer);

class CartItem extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-drawer');
    this.id = this.dataset.variantId;
    this.type = this.dataset.productType;
    this.tags = this.dataset.productTags;
    this.price = parseInt(this.dataset.productPrice, 10);
    this.sellingPlanId = this.dataset.sellingPlanId;
    this.lineItemKey = this.dataset.lineItemKey;

    this.removeButton = this.querySelector('button[name="remove"]');
    this.minusButton = this.querySelector('button[value="minus"]');
    this.plusButton = this.querySelector('button[value="plus"]');
    this.quantityElem = this.querySelector('input[name="quantity"]');

    this.quantity = parseInt(this.quantityElem.value, 10);

    this.removeButton.addEventListener('click', this.handleRemoveItem);
    this.minusButton.addEventListener('click', this.handleDecreaseQuantity);
    this.plusButton.addEventListener('click', this.handleIncreaseQuantity);
  }

  handleRemoveItem = (event) => {
    event.preventDefault();
    this.updateCart(0);
    this.remove();
  };

  handleDecreaseQuantity = (event) => {
    event.preventDefault();
    if (this.quantity > 1) {
      this.updateCart(this.quantity - 1);
    }
  };

  handleIncreaseQuantity = (event) => {
    event.preventDefault();
    this.updateCart(this.quantity + 1);
  };

  updateCart = (newQuantity) => {
    this.cart.updateCartItems({ [this.lineItemKey]: newQuantity });
    this.updateQuantity(newQuantity);
  };

  updateQuantity = (quantity) => {
    if (quantity < 1) {
      this.remove();
    } else {
      this.quantity = quantity;
      this.quantityElem.value = quantity;
    }
  };
}

customElements.define('cart-item', CartItem);
